import { Outlet, Navigate } from "react-router-dom";
import { member_init_without_token } from "src/DAL/ContentSetting/ContentSetting";
import { useEffect } from "react";

export default function LogoOnlyLayout() {
  const handleGetContentData = async () => {
    const result = await member_init_without_token();
    if (result.code === 200) {
      localStorage.setItem(
        `page_content`,
        JSON.stringify(result?.content_setting?.client_content_setting),
      );
      localStorage.setItem(
        `project_info`,
        JSON.stringify(result?.content_setting?.client_general_setting),
      );
    }
  };
  useEffect(() => {
    handleGetContentData();
  }, []);

  if (localStorage.getItem("token")) {
    return <Navigate to="/dashboard"> </Navigate>;
  }
  return <Outlet />;
}
